export const environment = {
  production: true,
  baseUrl: '/'
};
